import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/components/Layout/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalSettingsProvider"] */ "/vercel/path0/nextjs/src/context/GlobalSettings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/nextjs/src/hooks/use-current-page.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
